import { useEffect, useMemo, useState } from 'react'

import { GOOGLE_API_KEY, GOOGLE_APP_ID, GOOGLE_CLIENT_ID } from '@/config'
import { loadGoogleScripts } from './googleApis'
import {
  createGoogleDriveSource,
  type GoogleDriveKeys,
  hasEveryGoogleDriveKey,
} from './googleDriveSource'

const googleDriveKeysFromConfig = (): GoogleDriveKeys => ({
  clientId: GOOGLE_CLIENT_ID,
  apiKey: GOOGLE_API_KEY,
  appId: GOOGLE_APP_ID,
})

// Loads the Google scripts when the add-files screen mounts. Loading them on click gets the sign-in popup blocked.
const useGoogleScriptsLoaded = (shouldLoad: boolean) => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    if (!shouldLoad) return
    loadGoogleScripts().then(setIsLoaded)
  }, [shouldLoad])
  return isLoaded
}

export const useGoogleDriveSource = () => {
  const isLoaded = useGoogleScriptsLoaded(
    hasEveryGoogleDriveKey(googleDriveKeysFromConfig()),
  )
  return useMemo(() => {
    const source = createGoogleDriveSource(googleDriveKeysFromConfig())
    return isLoaded && source.isAvailable() ? source : null
  }, [isLoaded])
}
